<template>
    <div class="pneu-offer__sku-list-item" :class="{ 'pneu-offer__sku-list-item--aktion' : selectedTyre.DiscountPrice != null }" style="margin-top:2rem">
        <img class="pneu-offer__sku-list-brand" :src="images['brand_' + selectedTyre.BrandID]" :alt="selectedTyre.BrandName" :title="selectedTyre.BrandName" />
        <div class="pneu-offer__sku-list-name">
            <div class="pneu-offer__sku-list-item-brandname">{{selectedTyre.BrandName}}</div>
            <div class="pneu-offer__sku-list-item-title">{{selectedTyre.Title}}</div>
            <div class="pneu-offer__sku-list-item-description">{{selectedTyre.Description}}</div>
            <div class="pneu-offer__sku-list-item-season">{{selectedTyreSeason}}, {{tyreAmount}} {{strings['PneuOffer.Pieces']}}</div>
        </div>
        <div class="pneu-offer__sku-list-price">
            <div v-if="selectedTyre.DiscountPrice">
                <div class="pneu-offer__sku-list-item-discount-price">{{selectedTyre.DiscountPrice | formatPrice}}</div>
                <div class="pneu-offer__sku-list-item-instead-of-price">{{strings['PneuOffer.DiscountInsteadOf']}} {{selectedTyre.Price | formatPrice}}</div>
            </div>
            <div class="pneu-offer__sku-list-item-price" v-else>{{selectedTyre.Price | formatPrice}}</div>
            <div class="pneu-offer__sku-list-item-mwst">{{strings['PneuOffer.PerPiece']}}, {{mwstIncludedText}}</div>
        </div>
    </div>
</template>

<script>
    import { mapState, mapGetters } from 'vuex';

    export default {
        computed: {
            ...mapState([
                'enums',
                'strings',
                'images',
                'tyreAmount',
                'selectedTyre'
            ]),
            ...mapGetters([
                'mwstIncludedText'
            ]),
            selectedTyreSeason() {
                if (this.selectedTyre) {
                    return this.enums['Seasons'].find(x => x.value == this.selectedTyre.Season).text;
                } else {
                    return '';
                }
            }
        }
    };
</script>